import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-white pt-6 pb-10 sm:pt-24 sm:pb-32 lg:pb-40" data-id="element-193">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.02]" data-id="element-194"></div>
      <div className="absolute inset-y-0 right-0 w-1/2 bg-slate-50 rounded-l-full opacity-50 blur-3xl -z-10" data-id="element-195"></div>

      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-center" data-id="element-197">
          <div className="inline-flex items-center rounded-full px-3 py-1 text-[10px] sm:text-sm font-medium text-teal-700 bg-teal-50 ring-1 ring-inset ring-teal-600/20 mb-3 sm:mb-6" data-id="element-198">
            Sistema N°1 para Pediatras de Argentina
          </div>

          <h1 className="text-2xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 mb-3 sm:mb-6 leading-tight" data-id="element-199">
            Detectá, Actuá y Blindate Legalmente desde Hoy
          </h1>

          {/* Main mockup at 80% size — placed between the title and the subtitle */}
          <div className="flex justify-center my-4 sm:my-8" data-id="element-200">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative w-4/5 max-w-md" data-id="element-201">
              <div className="absolute -inset-4 bg-gradient-to-tr from-blue-100 to-teal-50 rounded-3xl blur-2xl opacity-50 -z-10" data-id="element-202"></div>
              <img src="https://cdn.magicpatterns.com/uploads/9NpyFvUDSGyjgMHXtcMFDD/heylloyd-image-1781011900642-Photoroom.png" alt="Megapack Guardia Pediátrica PRO" className="w-full object-contain drop-shadow-2xl" data-id="element-203" />
            </motion.div>
          </div>

          <p className="text-lg sm:text-3xl font-medium text-slate-600 mb-4 sm:mb-8" data-id="element-204">
            6 Tomos + 6 Bonos
          </p>

          <div className="flex items-center justify-center gap-2 text-[10px] sm:text-sm font-medium text-slate-500 mb-4 sm:mb-8" data-id="element-205">
            <span className="flex items-center gap-1" data-id="element-206">
              <ShieldCheck className="w-3 h-3 sm:w-4 sm:h-4 text-teal-600" data-id="element-207" />{' '}
              PDF Digital
            </span>
            <span data-id="element-208">·</span>
            <span data-id="element-209">Acceso Inmediato</span>
          </div>

          <p className="text-sm sm:text-lg text-slate-600 mb-5 sm:mb-10 max-w-2xl mx-auto" data-id="element-210">
            Protocolos, plantillas legales y herramientas clínicas para evaluar,
            estabilizar y actuar ante cualquier urgencia en tu guardia
            pediátrica.{' '}
            <strong className="font-semibold text-slate-900" data-id="element-211">
              Sin improvisar. Sin exponer tu matrícula.
            </strong>
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 justify-center" data-id="element-212">
            <motion.button whileTap={{
            scale: 0.96
          }} onClick={() => {
            document.getElementById('pricing-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="w-full sm:w-auto rounded-xl bg-blue-600 px-5 py-3 sm:px-8 sm:py-4 text-sm sm:text-lg font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all flex items-center justify-center gap-2" data-id="element-213">
              💥 QUIERO MI MEGAPACK AHORA
            </motion.button>
          </div>

          <div className="mt-5 sm:mt-10 grid grid-cols-2 sm:flex sm:items-center sm:justify-center gap-x-2 sm:gap-x-8 gap-y-2 text-[10px] sm:text-sm text-slate-600" data-id="element-214">
            <div className="flex items-center justify-center gap-1 sm:gap-2" data-id="element-215">
              <ShieldCheck className="w-3 h-3 sm:w-5 sm:h-5 text-teal-600" data-id="element-216" />
              <span className="font-medium" data-id="element-217">Garantía 7 días</span>
            </div>
            <div className="flex items-center justify-center gap-1 sm:gap-2" data-id="element-218">
              <Users className="w-3 h-3 sm:w-5 sm:h-5 text-blue-600" data-id="element-219" />
              <span className="font-medium" data-id="element-220">+800 Profesionales</span>
            </div>
            <div className="flex items-center gap-1 sm:gap-2 col-span-2 sm:col-span-1 justify-center" data-id="element-221">
              <div className="flex text-amber-400" data-id="element-222">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-2.5 h-2.5 sm:w-4 sm:h-4 fill-current" data-id="element-223" />)}
              </div>
              <span className="font-medium" data-id="element-224">4.9/5 Rating</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}